import * as React from 'react';
import './_ChatViewTopBar.scss';
import { IChatViewTopBarProps } from './types';
import { BackButton } from '../../../../base/components/BackButton/BackButton';
import { CHAT_VIEW_TITLE, CLASS_TOP_BAR_CHAT_VIEW } from './constants';

export function ChatViewTopBar({
    onBackClick,
}: IChatViewTopBarProps) {
    const className = CLASS_TOP_BAR_CHAT_VIEW;

    return (
        <div className={className}>
            <BackButton
                onClick={onBackClick}
                tooltipDirection={'down'}
            />
            <div className={className + '__title'}>{CHAT_VIEW_TITLE}</div>
        </div>
    );
}
